var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_box"},[_c('div',{staticClass:"top"},[_c('topBar',{staticClass:"topBar"})],1),_c('div',{staticClass:"blank_height"}),_c('div',{staticClass:"appmain_box"},[_c('router-view',{staticClass:"appmain"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }